<template>
  <div class="">
    <div class="formBox margbot" ref="searchBox">
      <!-- 查询条件 -->
      <el-form :inline="true" :model="searchFrom" class="demo-form-inline" size="mini" label-width="100px">
        <div class="formItemBox">
          <el-form-item label="创建时间:" class="item2">
            <el-date-picker
              v-model="createTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结算状态:">
            <el-select v-model="searchFrom.settlementStates" placeholder="请选择结算状态">
              <el-option v-for="item in ysSettlementList" :label="item.showName" :key="item.value"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付款部门:">
            <el-input v-model="searchFrom.payer" placeholder="请输入付款部门"></el-input>
          </el-form-item>
        </div>
        <div style="">
          <el-form-item>
            <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
            <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
            <el-button type="primary" size="mini" @click="delSettlementFn" v-if="btnFlg[0]">撤销对账</el-button>
          </el-form-item>
          <span>
            <el-form-item>
              <p class="margin0">收入合计：<span class="red">{{map.totalAmountSum}}</span>元</p>
            </el-form-item>
          </span>
        </div>
      </el-form>
    </div>
    <!--表格1-->
    <div :style="{height:h}">
      <el-table :data="tableList" ref="tableList"  class="tableComent" highlight-current-row @row-click="dianjixuanzhong" border height="100%" size="mini" style="width:100%"
      :header-cell-style="{background:'#F5F5F5',color:'black'}"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column label="操作"  width="100">
          <template slot-scope="scope">
            <el-button type="text" size="mini" :disabled='scope.row.isDisable' @click="daochuFN(scope.row)">导出明细</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="" label="账单号" width="170">
          <template slot-scope="scope">
            <el-button type="text" @click="ZDdetils(scope.row)">{{scope.row.billNo}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="" label="结算状态" >
          <!-- 0.未收款/未付款/待确认、1.部分收款/部分付款、2.已收款/已付款/已确认 -->
          <template scope="scope">
            <span class="wsStyle" v-show="scope.row.settlementStates == '0'">未确认</span>
            <span class="ysStyle" v-show="scope.row.settlementStates == '2'">已确认</span>
          </template>
        </el-table-column>
        <el-table-column prop="payer" label="付款部门" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="wayNumber" label="运单数量" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="totalAmount" label="收入合计(元)" :formatter="formatterRowEmpty">
        </el-table-column>
        <el-table-column prop="createTime" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div>
      <el-pagination
        background
        @current-change="handleCurrentChangeA"
        :current-page="searchFrom.pageNo"
        :page-size="searchFrom.pageSize"
        :page-sizes="[25,50,100]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChangeA"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { getSettlementBillList, delSettlementBill, getSettlementBillListTotal } from '@/api/newTMS'
import { emptyFn, dateTimeFormat, formatterRowEmpty, dateFormat1, getLastMonth } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  name: 'Freight',
  components: {
  },
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      dateTimeFormat: dateTimeFormat,
      loading: false,
      hejiMark: false,
      hejiDetail: '应收合计',
      ysSettlementList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '未确认',
          value: '0'
        },
        {
          showName: '已确认',
          value: '2'
        }
      ],
      emptyFn: emptyFn,
      h: '500px',
      xuanzhongArr: [],
      // 查询条件
      createTime: [],
      searchFrom: {
        insideOutsideType: 0,
        paymentFlag: 0,
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      },
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: ['01N00L0200'],
      tableList: [],
      map: {
        totalAmountSum: 0
      }
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/YScalculate')
    this.createTime = getLastMonth()
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 200 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 获取列表
    getList () {
      this.loading = true
      if (this.createTime) {
        this.$set(this.searchFrom, 'createTime', this.createTime)
      } else {
        this.$set(this.searchFrom, 'createTime', null)
      }
      getSettlementBillList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
      getSettlementBillListTotal(this.searchFrom).then(res => {
        this.map = res
      })
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
    },
    // 查询
    chaxun () {
      this.getList()
    },
    // 重置
    chongZhi () {
      this.searchFrom = {
        insideOutsideType: 0,
        paymentFlag: 0,
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      }
      this.createTime = getLastMonth()
      this.getList()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    handleSizeChangeA (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    // 账单详情
    ZDdetils (row) {
      this.$router.push({ name: 'HSYSdetils', query: { ysSettlementBillId: row.id, settlementPattern: row.settlementPattern, makeTicketYn: row.makeTicketYn, payee: row.payer } })
    },
    // 撤销对账
    delSettlementFn () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 1) {
        this.$alert('请选择一条数据进行操作', '系统提示')
      } else {
        // 未收款、未开票
        if (selectData[0].settlementStates != 0 || selectData[0].invoicingStates != 0) {
          this.$alert('只能选择未确认的账单撤销', '系统提示')
        } else {
          this.$confirm('是否执行操作?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            delSettlementBill({
              id: selectData[0].id
            }).then(res => {
              loading.close()
              this.$message({
                message: '撤销成功',
                type: 'success'
              })
              this.getList()
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }).catch(() => {})
        }
      }
    },
    // 导出
    daochuFN (row) {
      this.$set(row, 'isDisable', false)
      let from = {
        ysSettlementBillId: row.id
      }
      exportExcel(
        this.global.tmsPlus + '/settlementBill/exportInsideYsWayList',
        from,
        '应收明细列表'
      )
      this.$set(row, 'isDisable', true)
      setTimeout(() => {
        this.$set(row, 'isDisable', false) // 点击一次时隔两秒后才能再次点击
      }, 2000)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-form{
  width: 100%;
}
.inpBox .el-date-editor{
  width: 420px!important;
}
.box{
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill,270px);
  grid-auto-flow: row dense;
  .item1{
    grid-row-start: span 2;
  }
  .item2{
    grid-column-start: span 2;
    width: 540px;
  }
}
</style>
